import { observer } from 'mobx-react';
import { autoinject, bind, InfiniteScroll, inject, Loader } from 'Mri.Web.Common';
import * as React from 'react';
import { BiStore } from '../BI/BiStore';
import { DisplayListViewModel } from '../DisplayFilters/DisplayListViewModel';
import { IDashboardDateRange } from './Dashboard';
import { DashboardDisplay } from './DashboardDisplay';

export interface IDashboardDisplaysListProps {
    readonly vm: DisplayListViewModel;
    readonly selectedDateRange: IDashboardDateRange;
    readonly dateRange: Date[];
    readonly loading: boolean;
}

@autoinject
@observer
export class DashboardDisplayList extends React.Component<IDashboardDisplaysListProps> {
    public render() {
        const { hasMore, busy, loadMoreAsync, displays } = this.props.vm;

        return (
            <div className="d-flex flex-column h-100">
                <p className="w-100 text-center mb-1">
                    Displays &nbsp;
                    {<span>({this.biStore.dashboardDisplaysTitle})</span>}
                </p>

                <div className="card flex-grow-1">
                    <div className="container-fluid h-100 px-0 rounded">
                        <div className="row p-2">
                            <div className="col-4">
                                <div className="flex-items-center h-100">
                                    <small>
                                        <b>Unit Serial</b>
                                    </small>
                                </div>
                            </div>

                            <div className="col-4 text-center">
                                <div className="flex-items-center h-100">
                                    <small>
                                        <b>Last Reported</b>
                                    </small>
                                </div>
                            </div>

                            <div className="col-4">
                                <div className="flex-items-center h-100">
                                    <small>
                                        <b>Incidents</b>
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 top-display-items p-3" ref={this.setListContainerRef}>
                            <InfiniteScroll
                                throttle={100}
                                threshold={300}
                                hasMore={hasMore}
                                container={this.listCountainer}
                                onLoadMore={loadMoreAsync}
                                className="row "
                            >
                                {displays.map((d, idx) => (
                                    <DashboardDisplay
                                        display={d}
                                        dateRange={this.props.dateRange}
                                        selectedDateRange={this.props.selectedDateRange}
                                        key={idx}
                                    />
                                ))}

                                <Loader
                                    className="w-100 text-center"
                                    message="Loading Displays..."
                                    loading={this.props.loading || busy}
                                    showSpinner
                                />
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    @bind
    private setListContainerRef(r: HTMLDivElement | null) {
        this.listCountainer = r;
    }

    private listCountainer: HTMLDivElement | null = null;
    @inject
    private biStore!: BiStore;
}
